const AppUrlScheme = 'fondiapp://fondi';
const AppleStoreUrl = 'https://apps.apple.com/us/app/fondi/id1479328028?mt=8';
const GoogleStoreUrl = 'https://play.google.com/store/apps/details?id=com.Fondi.Fondi';

export { AppleStoreUrl, GoogleStoreUrl, AppUrlScheme };
